<template>
  <!--
    onelement hover
    call setActiveIndex(index)
    -->
  <!-- <router-link :to="item.url" :class="['accordion--item', 'pt-2xl', 'px-l']"> -->
    <!-- isactive || dimensions.width < 800 ? 'active':'', -->

  <a :class="['accordion--item',
            isactive ? 'selected':'',
            dimensions.width < 800 ? 'mobile':''
            ]">
            
    <div class="innerBg">      
      <div class="imgWrapper">
        <div class="imgOverlay reveal" :style="getImageBg()"></div>
      </div>
      <div class="colorOverlay"></div>
    </div>

    <!-- UPCOMING WEBINAR HIGHLIGHT -->
    <div class="upcoming" v-if="item.parent_id==3415">
      <div class="hpFont1">{{localize('upcoming_webinar')}} 
        <!-- <i class="fal fa-circle" style="color:#f9836b;font-size:10px;font-weight:400"></i> -->
      </div>
      <div class="hpFont1">{{item.summary}}</div>
    </div>

    <div :class="['textOverlay',isactive || dimensions.width < 800 ? 'extended':'']">
      <div class="text1Wrap">
        <div :class="['text1 hpFont1 hpBold',dimensions.width > 900 ? 'split-text':'']" 
          style="font-weight:500 !important;">
          {{item.subtitle}}
        </div>
      </div>
      <div class="text2Wrap">
        <div :class="['text2 hpFont2 hpBold',dimensions.width > 900 ? 'split-text':'']" 
          style="font-weight:500 !important;">
          {{item.title}}          
        </div>
      </div>      
      <div class="linkWrapper">
        <a class="textLink hpFont1 hpBold" :href="item.url" target="_blank">
          <span>{{getBtnText(item)}}</span>
          <span>{{getBtnText(item)}}</span>
        </a>
      </div>
    </div>    
  </a>
</template>
<script>

import { splitLines }         from "@/utils";
import { mapState } from "vuex";
export default {
  data()
  {
    return 
    {
      test:''
    };
  },  
  props: {
    item: {
      type: Object,
      required: true
    },
    isactive: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    },
    scrolledIndex:
    {
      type: Number,
      default: 0
    }
  },
  mounted() {
     //console.log("ITEM > ", this.item);
     //this.initText();
  },
  methods: {
    getBtnText(item)
    {
        return item.parent_id!=3415 ? this.localize('view_webinar') : this.localize('register');
    },
    getImageBg()
    {
      return "--index:"+this.index+";background-image:url('https://www.mis-implants.com/upload/"+this.item.img+"');"
    },
    ////
    parseUrl(url) {
      // console.log('parse url > ', url);
      let _url,
        locale = this.$route.params.locale;
      if (locale) {
        _url = "/" + locale + url;
      } else {
        _url = url;
      }
      // console.log("_URL > ", _url);
      return _url;
    }
  },
  computed: {
    ...mapState(["dimensions"]),
    buttons() {
      return _.filter(this.item.children, { type: "button" });
    },    
    accordionImage() {
      let image =
        this.dimensions.width < 600 && this.item.mobile_image
          ? this.item.mobile_image
          : this.item.image;
      // console.log("IMAGE > ", image, " :: ", this.image);
      return image ? `${this.$imageFolder}/${image}` : "";
    }
  }
};
</script>
<style>

  /* animation start  */
  .accordion--item .imgOverlay.reveal {
      opacity: 0;
      transition: all ease-in 0.8s;
      transition-delay: calc(var(--index) * 0.25s);
  }  
  .accordion--item .imgOverlay.reveal.active {
      opacity: 1;
  }  




  /* ////////////////// IMAGE BG LAYER //////////////////*/
/*   .hpFont2
  {
      font-size:clamp(1.2rem, 1.4vw, 2.5rem);
      line-height:clamp(1.2rem, 1.4vw, 2.5rem);
  }
 */
  .accordion--item .innerBg
  {
    height: 100%;
    width: 500px;
    min-height: 400px;
    position: absolute;
    transform: translateX(-40%);
    transition:all 0.6s ease-out-quad;    
  }
  .accordion--item.selected .innerBg
  {
    transform: translateX(-20%);
  }    
  .accordion--item.selected .colorOverlay
  {
    opacity: 1;
  }  
  .accordion--item .colorOverlay
  {
    opacity: 0;
    position: absolute;
    height: 100%;
    width: 150%;
    background-color: #2eadef;
    mix-blend-mode:multiply;
    transition:all 0.6s ease-out-quad;
  }
  .accordion--item .imgWrapper
  {
      position: absolute;
      height: 100%;
      width: 1000px;
      background-color: #f6f6f6; /* <<<<< this need to be the same color as the image bg */
  }
  .accordion--item .imgOverlay
  {
    
    background-position: top right;    
    background-repeat: no-repeat;
    background-size: cover;
    height: 100%;
    width: 500px;
  }


  /* TEXT LAYER */
  .upcoming
  {
    min-width: 20vw;
    padding: 24px 20px;
    position: absolute;
    top: 0px;left: 45%;
    background-color:#05283c; 
    /* background-color:#fb8267; */

    color:#fff;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
  }
  .upcoming div:nth-child(1)
  {
    font-weight: 400 !important;
  }
  .upcoming div:nth-child(2)
  {
    padding-top: 3px;
    font-weight: 300 !important;
  }

  .textOverlay
  {
    position: absolute;
    top: 0px;
    left: 45%;
    display:grid;
    align-content: center;
    height: 100%;
    /* width: 240px; width: 15vw;*/
    width: 14.5vw;
    opacity: 0;
    transition:all 0.6s ease-out-quad;
    /* border: solid 2px black; */
  }
  .textOverlay.extended
  {
    width: calc(15vw + 30px);
  }
  .textOverlay .text1
  {
    color: #fff;
    clear: both;
    width: 100%;
    display: block;
    font-weight: 500 !important;
  }
  .textOverlay .text2
  {
    color: #fff;
    clear: both;
    width: 100%;
    display:block;
    font-weight:500 !important;
    /* line-height:26px; */
  }

  


  .textOverlay .textLink
  {
    cursor: pointer;
    position: relative;
  }
  .textOverlay .textLink span:nth-child(1)
  {
    color: #fff;
    font-weight: 500 !important;
    border-radius: 30px;
    padding: 10px 20px;
    border: solid 2px #fff;
  }
  .textOverlay .textLink span:nth-child(2)
  {
    position: absolute;
    color: #09b6f4;
    font-weight: 500 !important;
    border-radius: 30px;
    padding: 10px 20px;
    border: solid 2px #fff;
    background-color: #fff;
    top: -12px;left: 0px;
    clip-path: inset(100% 0 0 0 );
    transition: all ease 0.4s;
  }
  .textOverlay .textLink:hover span:nth-child(2)
  {
    clip-path: inset(0 0 0 0 );
  }


  .accordion--item .linkWrapper
  {
    padding-top: 20px;
  }
  .accordion--item .textLink
  {
      opacity: 0;
  }
  .accordion--item.selected .textLink
  {      
      transition-delay: 0.8s !important;
      transition:all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94); 
      opacity: 1;
  }


  .accordion--item .xLine
  {
    /* line-height: 24px; */
  }
  .accordion--item .xLineText
  {      
      transition-delay: calc(0.14s * var(--line_index)) !important;      
      transition:all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
      transform: translateY(40px);opacity: 0;         
  }
  .accordion--item.selected .xLineText
  {      
      transform: translateY(0);opacity: 1;
  }
  .accordion--item .text1 .xLineText
  {
    font-weight: inherit;
    /* font-weight: 300 !important; */   
  }
  .accordion--item .text2 .xLineText
  {
    font-weight: inherit;
    letter-spacing: -1px !important;
    /* border: solid 2px red; */
    /* font-weight: 500 !important;    */
  }  
  .accordion--item.mobile .textOverlay,
  .accordion--item.selected .textOverlay
  {
    opacity: 1;
  }
  .text1Wrap
  {

  }
  .text2Wrap
  {
    padding-top: 0.3vw;
    padding-bottom: 0.5vw;
  }

    /* Portrait ipad pro */
    @media only screen 
      and (min-width: 1024px) 
      and (max-height: 1366px) 
      and (orientation: portrait) 
      and (-webkit-min-device-pixel-ratio: 1.5) {
        .accordion--item{
          height: 45vw;
          min-height: 45vw !important;
        }
        .accordion--item .innerBg{
          transform: translateX(-10%);
        }
    }

    /* Landscape ipad pro */
    @media only screen 
      and (min-width: 1024px) 
      and (max-height: 1366px) 
      and (orientation: landscape) 
      and (-webkit-min-device-pixel-ratio: 1.5) {
        .accordion--item .innerBg{
          transform: translateX(-30%);
        }
        .accordion--item.selected .innerBg {
            transform: translateX(-10%);
        }        
    }




  /* ----------- mobile ----------- */
  @media screen and (max-width: 835px) {
    .accordion--item
    {
        padding-right: 0px !important;
        margin-left: 5vw !important;
        flex: 1 !important;
        height: 100vw !important;
        scroll-snap-align: center;
    }
    .textOverlay
    {
      left: 30%;
    }
    .textOverlay.extended
    {
      width: 47vw;
    }
    .accordion--item.selected .innerBg 
    {
        transform: translateX(-40%);
    }
    .textOverlay .text1,
    .textOverlay .text2
    {
      color: #202020;
    }
    .accordion--item.selected .textOverlay .text1,
    .accordion--item.selected .textOverlay .text2
    {
      color: #fff;
    }
    .accordion--item .imgOverlay    
    {
      opacity: 0.5;
    }
    .accordion--item.selected .imgOverlay    
    {
      opacity: 1;
    }
    .upcoming
    {
        top: 10px;
        left: initial;
        border-radius: 20px;
        right: 10px;      
    }
  }  



</style>
<style lang="stylus" scoped>
.btn-group
	float left
.link-group
  position relative
  z-index 9
  +below(415px)
    pad('m', top)
  a
    color gray_8
      /.education &
      /.company &
      /.research_and_development &
        color gray_1
    &:hover
      color blue_5
.accordion--item  
  overflow hidden
  position relative
  background #f6f6f6
  border-radius 25px
  transform translateZ(0)
  transition all 600ms ease-out-quad
  //transition:  all 1200ms cubic-bezier(.74,.26,.48,.92)

  will-change flex
  backface-visibility hidden
  user-select none
  -webkit-tap-highlight-color transparent
  margin-bottom 20px
  width 100%
  display block
  &:active
  &:focus
    outline 0
  .innerBg
    height 100%
    width 500px
    min-height 400px
    position relative
    img
      object-fit cover
      height 100%
      position absolute
      //transform translate(0, 0)
  h2
    z-index 11
    position relative
    display inline-block
    max-width 200px
    a
      color gray_8
      /.education &
      /.company &
      /.research_and_development &
        color gray_2
      &:hover
        color blue_5
  +above(1800px)
    .imgOverlay    
      width 33vw
    .colorOverlay
      width 250%
    .text2
      //line-height 40px
  img
    position absolute
    bottom 0
    right 0
    transform translate(25%, 0)
    transition transform 0.6s ease-out-quad, opacity 0.6s ease-out-quad
    will-change transform
    backface-visibility hidden
    /.education &
    /.company &
    /.research_and_development &
      height auto
      left 50%
      max-height 45%
      top 50%
      transform translate(-50%, -10%)
      +below(1100px)
        height 55%
        left 100%
        +landscape()
          height 120px
          transform translate(-120%, -10%)
      +below(815px)
        max-height 120px

    max-width 26vw
    +below(1400px)
      max-width 20vw
      transform translate(13%)
    +below(1100px, orientation: landscape)
      max-width 70%
      transform translate(0, 15%)
    +below(600px)
      transform translate(-30%, -20%)

    +portrait()
      max-height 100%
      transform none
      /.education &
      /.company &
      /.research_and_development &
        top auto
        left 100%
        transform translate(-120%, -20%)
        width auto
        height 150px
        max-width initial
  +below(1100px)
    flex 0 0 calc(50% - 10px)
    height 300px
  +below(815px)
    height 220px
  +portrait()
    // min-height 35vh
    pad('2xl', x)
  +below(1100px, orientation: portrait)
    pad('xl', x)
  +below(600px)
    min-height 250px
    width 100%
    flex 1
    display block
    border none !important
    //padding 20px
    //marg('xl',bottom)
    &:last-child
      //margin 0
    flex-direction row
    max-width initial
    .btn
      flex none
      marg('m',left)
    img
      max-width 60%
  +above(1101px)
    flex 1
    +landscape()
      min-height 400px
      +above(unit($max, 'px'))
        min-height 400px
    &:not(:last-child)
      margin-right 10px  
      //border-right 10px solid transparent
    &:not(:first-child)
      margin-left 10px  
      //border-left 10px solid transparent    
    &.selected //&:hover
      flex 3
      .innerBg
        img
          //transform translateX(-0.5)
      .ximg
        transform translate(0, 0)
        z-index -1
        /.education &
        /.company &
        /.research_and_development &
          transform translate(-50%, -10%)
    /* ----------- iPad Pro ----------- */
  
  /* Portrait and Landscape ////////////////////////// */
  /* Portrait and Landscape ////////////////////////// */
  /* Portrait and Landscape ////////////////////////// */
  /* Portrait and Landscape ////////////////////////// */
  @media screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 1.5)
    flex 1 1 40px
    //height 45vh
    //min-height 40vh !important
    &.selected 
      flex 50%
    img
      top initial !important
      left initial !important
      right 0 !important
      bottom 0 !important
      transform translate(-25px, -25px) !important

</style>
